import { z } from "zod";
import { timestampsSchema } from "./common";
import { listQueryBaseSchema } from "./list-query";
import { mediaDtoSchema } from "./media";

export const adDtoSchema = z
  .object({
    id: z.string().uuid(),
    title: z.string(),
    link: z.string().nullable(),
    image: mediaDtoSchema.nullable(),
  })
  .extend(timestampsSchema.shape);
export type AdDTO = z.infer<typeof adDtoSchema>;

export const adUpsertSchema = z.object({
  title: z.string().min(1),
  link: z.url().optional(),
});
export type AdUpsertInput = z.infer<typeof adUpsertSchema>;

export const adsListQuerySchema = listQueryBaseSchema;
export type AdsListQuery = z.infer<typeof adsListQuerySchema>;
